// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SGdZ6","colBig":"styles_colBig__23tOX","colSmall":"styles_colSmall__gaqiF"};